// extracted by mini-css-extract-plugin
module.exports = {"item":"Features_item__3Xiew","featuresRow":"Features_featuresRow__3KIbl"};